import {
  FaceSmileIcon,
  ChartBarSquareIcon,
  CursorArrowRaysIcon,
  DevicePhoneMobileIcon,
  AdjustmentsHorizontalIcon,
} from "@heroicons/react/24/solid";

const benefitOne = {
  title: "Set your skills → See conversations → Reply first",
  desc: "",
  infographic: "convergence",
  bullets: [
    {
      title: "Define what you do",
      desc: "Add the skills and topics you offer. We watch Reddit and LinkedIn so you only see conversations that fit.",
      icon: <FaceSmileIcon />,
    },
    {
      title: "Get matching conversations in real time",
      desc: "When someone asks for help you can provide, we surface it. No scrolling. No 47 proposals already in.",
      icon: <ChartBarSquareIcon />,
    },
    {
      title: "Reply and close",
      desc: "Jump into the thread or DM. You’re not bidding—you’re helping. That’s how you win the client.",
      icon: <CursorArrowRaysIcon />,
    },
  ],
};

const benefitTwo = {
  title: "Clients while you work",
  desc: "",
  infographic: "clientfeed",
  bullets: [
    {
      title: "No doom-scrolling",
      desc: "See live opportunities that match your skills. Budget and source right there—Reddit and LinkedIn in one feed.",
      icon: <DevicePhoneMobileIcon />,
    },
    {
      title: "Find clients fast, get paid",
      desc: "People asking for help, with budget and context. Reach out when it fits. Save time, close faster.",
      icon: <AdjustmentsHorizontalIcon />,
    },
    // {
    //   title: "Dark & Light Mode",
    //   desc: "Nextly comes with a zero-config light & dark mode. ",
    //   icon: <SunIcon />,
    // },
  ],
};

export { benefitOne, benefitTwo };
